module.exports = __webpack_public_path__ + "img/manually.d38cc4d1.svg";